import React from 'react'
import CreactAccount from '../../../components/organisms/admin/account/CreactAccount'

type Props = {}

const CreateAccountPage = (props: Props) => {
  return (
    <CreactAccount />
  )
}

export default CreateAccountPage